<script setup lang="ts">
import { useStore } from "vuex";
import { watch, computed } from "vue";
import OptionSelector from "@/components/UI/OptionSelector.vue";
import OptionSelectorWrapper from "@/components/UI/OptionSelectorWrapper.vue";

const i18n = window.measurementSelectorVariables.i18n;
const kpsSettings = window.measurementSelectorVariables;
const store = useStore();

const exportShape = computed(() => store.getters.exportShape);
const activeEdgeFinish = computed(() => store.getters.activeEdgeFinish);
const getEdgeFinishMethods = computed(() => store.getters.getEdgeFinishMethods);
const getDefaultEdgeFinish = computed(() => store.getters.getDefaultEdgeFinish);
const usePriceFromServer = computed(() => store.getters.usePriceFromServer);

watch(activeEdgeFinish, async (newValue: string, oldValue: string) => {
	if (!usePriceFromServer.value) {
		return;
	}
	if (newValue !== oldValue) {
		store.dispatch("retrieveDxfDefinitionDebounced");
	}
});

function updateEdgeFinish(e: InputEvent) {
	const target = (e.target as HTMLInputElement);
	store.commit("updateActiveEdgeFinish", target.value);
}

function getBadge(value: string): string {
	if (getDefaultEdgeFinish.value === value && exportShape.value === 'rectangle') {
		return i18n.edgeFinish.meta.free;
	} else if (getDefaultEdgeFinish.value !== value) {
		return i18n.edgeFinish.meta.premium;
	}
}
</script>

<template>
	<option-selector-wrapper>
		<!-- name is hardcoded in app/Measuring/SizeValidator.php -> determine_sawing_method() -->
		<option-selector
			v-for="{ value, label } in getEdgeFinishMethods"
			name="edge-finish"
			:key="value"
			:isActive="activeEdgeFinish === value"
			:activeValue="activeEdgeFinish"
			:value="value"
			:image="`${kpsSettings.assets}/images/${value}-light.png`"
			:badge="getBadge(value)"
			:label="label"
			:onInput="updateEdgeFinish"
		/>
	</option-selector-wrapper>
</template>
